import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {JwtUtil} from '../../utils/JwtUtil';
import {Observable} from 'rxjs';
import {Keys, StorageService} from '../../service/storage.service';
import {Toaster} from '../../toaster/Toaster';

@Injectable()
export class AuthTokenValidityInterceptor implements HttpInterceptor {
    private readonly router: Router;
    private readonly jwtUtil: JwtUtil;
    private readonly storageService: StorageService;

    constructor(storageService: StorageService, jwtUtil: JwtUtil, router: Router) {
        this.storageService = storageService;
        this.jwtUtil = jwtUtil;
        this.router = router;
    }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const authToken = this.storageService.getItem(Keys.TOKEN);
        if (authToken && this.jwtUtil.isTokenExpired(authToken)) {
            this.storageService.clearSessionAndLocalStorage();
            this.router.navigate(['/login']);
            Toaster.toast('Your session has expired, please login');
            return;
        }
        return next.handle(request);
    }
}
